import { Directive } from '@angular/core';

@Directive({
  selector: '[appFormControlLabel]',
  standalone: true,
})
export class FormControlLabelDirective {}
